import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import FacebookStyleLoader from "../ChildComponents/Loading";
import { verifyToken } from "../Utils/authUtils";

const AuthRedirectRoute = ({ children }) => {
  const { token } = useSelector((state) => state.user);
  const [isTokenValid, setIsTokenValid] = useState(null);

  useEffect(() => {
    const validateToken = async () => {
      if (!token) {
        setIsTokenValid(false);
        return;
      }

      const tokenIsValid = await verifyToken(token?.token);
      setIsTokenValid(tokenIsValid);
    };

    validateToken();
  }, [token]);

  if (isTokenValid === null) {
    return <FacebookStyleLoader />;
  }

  if (token && isTokenValid) {
    return <Navigate to="/admin" />;
  }

  return children;
};

export default AuthRedirectRoute;
